let init = function (prefix) {

  let p = prefix;
  let last_known_scroll_position = 0;
  let ticking = false;
  let navbar, navbarAnchorPosition, navbarLimitPosition;
  let navbarAnchor = document.getElementById(p + "navbar");
  let navbarLimit = document.getElementById(p + "navbar-limit");

  function doSomething() {
    navbar = document.getElementById(p + "navbar");
    if (window.pageYOffset >= navbarAnchorPosition && window.pageYOffset < navbarLimitPosition) {
      navbar.classList.add("sticky")
    } else {
      navbar.classList.remove("sticky");
    }
  }

  document.addEventListener('scroll', function () {
    last_known_scroll_position = window.scrollY;
    navbarAnchor = document.getElementById(p + "navbar-anchor");
    if (!ticking) {
      window.requestAnimationFrame(function () {
        doSomething(last_known_scroll_position);
        ticking = false;
        navbarAnchorPosition = navbarAnchor.offsetTop;
        navbarLimitPosition = navbarAnchorPosition + navbarLimit.offsetTop;

      });

      ticking = true;
    }
  });

};

export default {init};
